import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidepanel-expand",
  "use": "icon-sidepanel-expand-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-sidepanel-expand\"><path d=\"m21.8 10-4.6 4.6c-.8.8-.8 2 0 2.8l4.6 4.6 1.4-1.4-4.6-4.6 4.6-4.6zM15 10l-4.6 4.6c-.8.8-.8 2 0 2.8L15 22l1.4-1.4-4.6-4.6 4.6-4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol